var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('div',{staticClass:"top-header"},[(_vm.showTopBar)?_c('TopHeader'):_vm._e()],1),_c('div',{staticClass:"app-body"},[(_vm.showTopBar)?_c('LeftTabs'):_vm._e(),_c('div',{staticClass:"app-view"},[_c('router-view',{key:_vm.$route.path})],1)],1),(_vm.showTopBar)?_c('FootPage'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }